import { get, post, put, del } from '../utils/http';
import { encrypt } from '../utils/index';

/**
 * 查询[圆通，人保达达]租户下的保障方案项目
 * @param {*} params
 * agentId 坐席账号Id
 * planCode 方案代码。中华联合哈啰需要,用于区分景区车和非景区车
 * underPolicyCompanyId 承保机构ID
 */
export function getPlansByTenant(params) {
    return get('/api/lossAss/tenant/plans', params);
}

/**
 * 获取大案疑案类型列表
 * @param {*} params
 * tenantCode
 */
export function getMajorCaseTypes(params) {
    return get('/api/lossAss/report/majorCaseTypes', params);
}

/**
 * 查询[丹鸟，南京大排档，圆通，保时捷]雇主公司数据
 * @param {*} params
 * agentId
 */
export function getActiveEmployer(params) {
    return get('/api/lossAss/employer/active', params);
}
/**
 * 获取风控的风险等级
 * @param {*} params
 * agentId
 */
export function getRiskLevels(params) {
    return get('/api/riskContr/level', params);
}
/**
 * 获取[追星保]常量类型配置列表
 * @param {*} constantType
 * 枚举值： reportTirePositions 轮胎位置；reportVehicleUsages 车辆使用性质；reportTireDamageTypes 轮胎损伤类型；policyOrderType 投保类型；siteCaseType 现场案件类型
 */
export function getConstantTypes(constantType) {
    return get(`/api/constant/${constantType}`);
}
/**
 * 查询产品类型
 * @param {*} params
 * agentId
 */
export function getProductTypes(params) {
    return get('/api/lossAss/yuantong/productType', params);
}
/**
 * 获取险种列表
 * @param {*} params
 * tenantId
 */
export function getRiskTypes(params) {
    return get('/api/lossAss/riskProduct/riskTypes', params);
}
/**
 * 获取机构列表
 * @param {*} params
 * pageIndex
 * pageSize
 * searchTenant
 * overQuery 跨机构查询 0:否 1:是
 */
export function getOrganizations(params) {
    return get('/api/lossAss/organizitions/simple', params);
}
/**
 * 获取案件详情
 * @param {*} flowId
 * @param {*} params
 * from
 */
export function getReportInfo(flowId, params) {
    return get(`/api/lossAss/getReportInfo/${flowId}`, params);
}
/**
 * 更新工单详情
 * @param {*} agentId 
 * @param {*} params 
 * @returns 
 */
export function updateReport(agentId, params) {
    return post(`/api/lossAss/newReport?agentId=${agentId}`, params)
}
/**
 * 导出详情
 * @param {*} params
 */
export function exportReportDetail(params) {
    return post('/api/lossAss/download_report_detail', { encryptData: encrypt(params) });
}
/**
 * 导出列表
 * @param {*} params
 */
export function exportReportData(params) {
    return post('/api/lossAss/download_report_data', { encryptData: encrypt(params) });
}

/**
 * 导出邮寄材料
 * @param {*} params
 */
export function exportExpressMaterial(params) {
    return post(
        '/api/lossAss/expressMaterial/export',
        params,
        { ArrayBuffer: true },
        { responseType: 'blob' }
    );
}
/**
 * 查询坐席列表
 * @param {*} params
 * pageIndex
 * pageSize
 * searchStr
 * agentRole
 * searchTenant
 * searchOrgAccount
 */
export function getAgentList(params) {
    return get('/api/agents/simple', params);
}
/**
 * 搜索定损中心工单
 * @param {*} params
 * pageIndex
 * pageSize
 * ...其他
 */
export function getReportList(params) {
    return post('/api/lossAss/getReports/listPage', { encryptData: encrypt(params) });
}
/**
 * 获取可指派坐席
 * @param {*} params
 * tenant
 * orgAccount
 */
export function getAssignAgents(params) {
    return get('/api/departments', params);
}
/**
 * 工单指派给坐席
 * @param {*} params
 * flowIds 工单流水号
 * targetAgentId 要指派到的坐席
 * agentId 当前进行指派操作的管理员
 */
export function assignToAgent(params) {
    return put('/api/lossAss/report/v1.0/assignToAgent', params);
}
/**
 * 获取导入指派案件模板
 */
export function getTemplateByImportAssignment() {
    return get('/api/lossAss/report/v1.0/assignToAgent/file')
}
/**
 * 解析指派案件excel
 * @param {*} params 
 * file
 * @returns 
 */
export function getAssignmentReportsByFile(params) {
    return post('/api/lossAss/report/v1.0/assignToAgent/import', params);
}
/**
 * 查询excel案件指派的案件数，定损任务数
 * @param {*} params 
 * file
 * @returns 
 */
export function getAssignmentInfoByFile(params) {
    return post('/api/lossAss/report/v1.0/assignToAgent/file', params);
}
/**
 * 获取我的任务列表
 * @param {*} params
 * pageSize
 * pageIndex
 * searchType
 * searchCont
 * tagKey
 * orderBy
 * order
 */
export function getMyTaskList(params) {
    return get('/api/lossAss/myTask', { encryptData: window.encodeURIComponent(encrypt(params)) });
}
/**
 * 我的任务，核赔推荐列表
 * @param {Object} params
 * pageSize
 * pageIndex
 * searchType
 * searchCont
 * orderBy
 * order
 */
export function getRecommendCheckedReports(params) {
    return get('/api/lossAss/myTask/recommend/checked', { encryptData: window.encodeURIComponent(encrypt(params)) });
}
/**
 * 我的任务，撤案推荐列表
 * @param {*} params
 * pageSize
 * pageIndex
 * searchType
 * searchCont
 * orderBy
 * order
 */
export function getRecommendWithdrawReports(params) {
    return get('/api/lossAss/myTask/recommend/withdraw', { encryptData: window.encodeURIComponent(encrypt(params)) });
}
/**
 * 查询核赔推荐备注
 * @param {*} params
 * flowId
 */
export function getRecommendCheckedRemark(params) {
    return get('/api/lossAss/report/recommendChecked/remark', params);
}
/**
 * 修改核赔推荐备注
 * @param {*} params
 * flowId
 * remark
 */
export function updateRecomendCheckedRemark(params) {
    return post('/api/lossAss/report/recommendChecked/remark', params);
}
/**
 * 获取撤案推荐规则，只针对于案件的撤案推荐为待处理状态可查询
 * @param {*} params
 * flowId
 */
export function getRecommendWithdrawInfo(params) {
    return get('/api/lossAss/report/recommendWithdraw/info', params);
}
/**
 * 修改撤案推荐状态，只针对于案件的撤案推荐为待处理状态可查询
 * @param {*} params
 * flowId
 * withdrawState
 * nextRecommendWithdraw YYYY-MM-DD
 */
export function updateRecomendWithdrawStatus(params) {
    return put('/api/lossAss/report/recommendWithdraw/info', params);
}
/**
 * 获取我的任务列表其他数据
 * @param {*} params
 * agentId
 */

export function getMyTaskDealing(params) {
    return get('/api/lossAss/myTask/dealing', params);
}

/**
 * 获取消息列表
 * @param {*} params
 * pageSize
 * pageIndex
 */
export function getChatMsg(params) {
    return get('/api/report/msgboards/v2', params);
}
/**
 * 获取会员消息详情内容
 * @param {*} params
 * flowId
 * role
 * agentId
 */
export function getChatMsgDetail(params) {
    return get(`/api/report/msgboard`, params);
}
/**
 * 获取最近会话
 * @param {*} params
 * IndexStart
 */
export function getRecentCall(agentId, params) {
    return get(`/api/findWeekRecentCallByAgent/eclaim/${agentId}`, params);
}

/**
 * 按分类查询图片列表信息
 * @param {*} params
 * @returns
 */

export function getPicsClassify(params) {
    return get('/api/lossAss/superView/pics/classify', { encryptData: window.encodeURIComponent(encrypt(params)) });
}

/**
 * 查询保单
 * @param {*} params
 * @returns
 */

export function searchPolicy(params) {
    return get('/api/lossAss/dajia/employer/policies', params);
}

/**
 * 查询前海雇主保单
 * @param {*} params
 * @returns
 */
export function QIANHAI_SearchPolicy(params) {
    return get('/api/lossAss/qianhai/employer/policies', params);
}

/**
 * 更新前海雇主保单
 * @param {*} params
 * @returns
 */
export function QIANHAI_updateReportPolicy(params) {
    return post('/api/lossAss/qianhai/employer/report/policy', params);
}
/**
 * 前海手动创建保单
 * @param {*} flowId 
 * @param {*} params 
 * flowId
 * policyNo
 */
export function updatePolicyNoByQianhai(flowId, params) {
    return put(`/api/lossAss/qianhai/employer/${flowId}/policyNo`, params);
}

/**
 * 更新工单的保单信息
 * @param {*} params
 * @returns
 */

export function updateReportPolicy(data) {
    return post('/api/lossAss/dajia/employer/report/policy', data);
}
/**
 * 删除图片
 * @param {*} params
 * flowId
 * picIds: []
 */
export function deletePics(params) {
    return del('/api/lossAss/superView/pics/recyclebin', params);
}
/**
 * 恢复回收站的图片
 * @param {*} params
 * picIds
 * label
 * @param {*} headers
 */
export function recoverPics(params) {
    return put('/api/lossAss/superView/pics/recyclebin/recover', params);
}

/**
 * 获取回收站列表
 * @param {*} params
 * flowId
 */
export function getRecycleBinList(params) {
    return get('/api/lossAss/superView/pics/recyclebin', { encryptData: window.encodeURIComponent(encrypt(params)) });
}

/**
 * 更新图片旋转角度
 * @param {*} params
 * flowId
 * imgId
 * rotate
 * @param {*} headers
 */
export function updateRotate(params) {
    return put('/api/lossAss/utils/rotate', params);
}

/**
 * 坐席设置收款人银行退票
 * @param {*} params
 * @returns
 */
export function payeeBankFound(params) {
    return post('/api/lossAss/report/payeeBankFound', params);
}

/**
 * 坐席设置收款人打款成功
 * @param {*} params
 * @returns
 */
export function payeeRemitted(params) {
    return post('/api/lossAss/report/payeeRemitted', params);
}

/**
 * 坐席设置收款人重新打款
 * @param {*} params
 * @returns
 */
export function payeeReRemitt(params) {
    return post('/api/lossAss/report/payeeReRemitt', params);
}
/**
 * 保司影像缺失并重新上传
 * @param {*} params
 * agentId
 * flowId
 */
export function reUploadImage(params) {
    return post('/api/lossAss/report/reUploadImage', params);
}

/**
 * 查询案件的处理记录
 * @param {*} params
 * flowId
 */
export function getReportTransferRecords(flowId) {
    return get(`/api/lossAss/getReportTransferRecords/${flowId}`);
}

/**
 *  查询案件的备注记录
 * @param {*} params
 * flowId
 */
export function getRemarks(flowId) {
    return get(`/api/lossAss/getRemarks/${flowId}`);
}

/**
 *  查询案件的打款记录
 * @param {*} params
 * flowId
 */
export function getPayRecords(params) {
    return get(`/api/lossAss/report/payRecords`, params);
}

/**
 *  设置是否诉讼
 * @param {*} params
 *
 */
export function setRelateComplaint(params) {
    return post(`/api/lossAss/report/relateComplaint`, params);
}
/**
 * 新建或追加投诉
 * @param {*} params 
 * flowId
 * agentId
 * types 投诉内容类型， 多项用英文逗号分隔 LOWER_PROCESS：进度慢，TOO_COMPLEX：太复杂，MONEY_DISSENT：金额异议，SERVICE：服务态度，OTHERS：其他，
 * level 投诉等级 ， COMPL_BASIC：基础投诉， COMPL_95500： 955投诉， COMPL_COMPANY：保险公司投诉， COMPL_BANK_COMM： 保监投诉
 * content 投诉内容详情
 */
export function createNewComplaint(params) {
    return post('/api/lossAss/complaint', params);
}
/**
 * 查询投诉记录信息记录
 * @param {*} params 
 * flowId
 */
export function getComplaintRecords(params) {
    return get('/api/lossAss/complaint', params)
}
/**
 *  查询全量的案件数据，和全量的定损任务数量
 * @param {*} params
 *
 */
export function queryAssignToAgentAll(params) {
    return post(`/api/lossAss/report/v1.0/assignToAgent/all`, params);
}

/**
 *  全部指派接口
 * @param {*} params
 *
 */
export function assignToAgentAll(params) {
    return put(`/api/lossAss/report/v1.0/assignToAgent/all`, params);
}
/**
 * 根据导入的文件进行指派
 * @param {*} params 
 * targetAgentId
 * file 文件id
 * type 1 常规指派，2 定损指派
 */
export function assignToAgentByFile(params) {
    return put('/api/lossAss/report/v1.0/assignToAgent/file', params);
}
/**
 * OCR识别
 * @param {*} ocrType 识别类型 vehicle-行驶证, idcard-身份证, bankcard-银行卡, driving-驾驶证, medical-票据明细
 * @param {*} params
 * imageUrl
 * flowId
 * lossId
 * lossType thirdParty 三者 lossAssCar 标的
 */
export function getOcrVehicle(ocrType, params) {
    return post(`/api/lossAss/ocr/agent/${ocrType}`, params);
}
/**
 * 工单修改.OCR识别
 * @param {*} ocrType
 * @param {*} params
 * flowId
 * lossId
 * lossType thirdParty 三者 lossAssCar 标的
 * data {Object}
 */
export function updateReportByOCR(ocrType, params) {
    return put(`/api/lossAss/report/ocr/${ocrType}`, params);
}
/**
 * 医疗发票校验是否重复
 * @param {*} params
 * flowId
 * lossId
 * lossType thirdParty 三者 lossAssCar 标的
 * data {Object}
 */
export function checkMedicalRepeat(params) {
    return post('/api/lossAss/report/ocr/medical/repeat', params);
}
/**
 * 票据验真
 * @param {*} params
 * id 图片id
 * flowId
 * original_url
 * tenant 租户id
 * userId 所属用户id
 */
export function getTicketOcr(params) {
    return post('/api/lossAss/report/pic/ticket/ocr', params);
}
/**
 * 添加备注
 * @param {*} flowId
 * @param {*} params
 * content
 * agentId
 * agentName
 * @returns
 */
export function createRemark(flowId, params) {
    return put(`/api/lossAss/report/${flowId}/remark`, params);
}
/**
 * 获取工单下次追踪时间
 * @param {*} params
 * flowId
 * agentId
 * @returns
 */
export function getNextFollowTime(params) {
    return get('/api/lossAss/report/follow', params);
}
/**
 * 定损任务退回
 * @param {*} params
 * flowId
 * agentId
 * agentName
 * content 退回消息
 * voince undefined(已废弃)
 * @returns
 */
export function returnDefLossTask(params) {
    return put('/api/lossAss/deflossTask/return', params);
}
/**
 * 资料退回/查勘退回
 * @param {*} flowId
 * @param {*} params
 * agentId
 * agentName
 * content 退回消息
 * voince undefined(已废弃)
 * @returns
 */
export function returnTask(flowId, params) {
    return put(`/api/lossAss/report/${flowId}/returnedReason`, params);
}
/**
 * 更新跟踪信息
 * @param {*} params
 * flowId
 * agentId
 * followTime
 * followType
 * nextTime
 * @returns
 */
export function updateFollowInfo(params) {
    return put('/api/lossAss/report/follow', params);
}

// 坐席上传图片前进行校验。true 表示能继续上传
export function shotPicsCheck(params) {
    return get('/api/lossAss/shotPics/check', params);
}
/**
 * 获取风险标记
 * @param {*} params
 * flowId
 * agentId
 */
export function getRiskFlag(params) {
    return get('/api/riskContr/flag', params);
}

/**
 * 查询标签关联的案件列表
 * @param {*} params
 * flowId
 * agentId
 * riskFlagId
 */
export function getReportsByRiskFlag(params) {
    return get('/api/riskContr/flag/aboutReports', params);
}
/**
 * 获取分险列表
 * @param {*} params
 * agentId
 * @returns
 */
export function getLevelList(params) {
    return get(
        '/api/riskContr/level',
        params,
        {},
        {
            cache: true
        }
    );
}
/**
 * 修改风险等级
 * @param {*} params
 * flowId
 * agentId
 * riskLevelId
 * reason
 */
export function updateLevel(params) {
    return put('/api/riskContr/flag/update/manual', params);
}
/**
 * 调用图片阅读接口
 * @param {*} params 
 * flowId
 * agentId
 * @returns 
 */
export function setReadStatusByPics(params) {
    return get('/api/lossAss/shotPics/agentView', params);
}


/**
 * 回访完成
 * @param {*} params 
 * flowId
 * agentId
 * review 回访结果，1: 多次未接通， 2: 回访成功 
 */
export function finishClientReview(params) {
    return post('/api/lossAss/report/clientReview', params);
}
/**
 * 提交定损任务的定损结论
 * @param {*} params 
 * flowId
 * agentId
 * lossId
 * lossType 需要定损的类型， injury: 人伤， damage: 物损， carLoss: 车损
 * defLossState 定损状态， checked: 定损通过， nonecheck: 无需定损，
 * @returns 
 */
export function updateLossConclusion(params) {
    return post('/api/lossAss/report/deflossTask/conclusion', params);
}
/**
 * 发送定损视频短信
 * @param {*} params 
 * flowId
 * lossId
 * phoneNumber
 * smsType 短信类型，DEF_LOSS: 定损类型短信
 * agentId
 * @returns 
 */
export function sendLossMessage(params) {
    return post('/api/lossAss/cpic/sms', params);
}
/**
 * 检查饿了么来源的案件是否高危风险
 * @param {*} params 
 * @returns 
 */
export function inspectElemeHighRisk(params) {
    return get('/api/lossAss/report/eleme/highRisk/inspect', params);
}
/**
 * 设置案件银行退票
 * @param {*} params 
 * flowId
 */
export function setBankRefoundOfReport(params) {
    return post('/api/lossAss/report/agentBankRefound', params);
}
/**
 * 修改案件状态
 * @param {*} params 
 * flowId
 * state
 * subState
 * agentId
 */
export function updateReportState(params) {
    return get('/api/lossAss/cpic/tpa/report/resetState', params).then(res => {
        const businessFailed = res
            && res.result
            && typeof res.result.success === 'boolean'
            && res.result.success === false;
        if (res.errCode !== 0 || businessFailed) {
            throw new Error((businessFailed && res.result && res.result.errInfo) || res.errInfo || '操作失败');
        }
        return res.result;
    })
}
/**
 * 领取定损任务
 * @param {*} params 
 * flowId
 * agentId
 */
export function acceptLossTask(params) {
    return get('/api/lossAss/deflossTask/agentAccept', params);
}
/**
 * 领取任务
 * @param {*} params 
 * flowId
 * agentId
 */
export function acceptTask(params) {
    return get('/api/lossAss/report/agentaccept', params);
}
/**
 * 标记大案疑案
 * @param {*} params 
 * flowId
 * agentId
 * isMajorCase true: 是， false: 否
 * majorCaseType 案件类型可配置，配置内容从 report.tenant.majorCasesOpts 读取，重伤案件： SERIOUS_INJURY，死亡案件： DEATH，疑难案件： HARD，
 */
export function markMajorCase(params) {
    return post('/api/lossAss/report/markMajorCase', params);
}
/**
 * 设置/取消设置失联
 * @param {*} params 
 * flowId
 * isLostContactCsr
 */
export function setLostContact(params) {
    return post('/api/lossAss/report/lostcontact/customer', params);
}
/**
 * 设置/取消设置长期跟进
 * @param {*} params 
 * flowId
 * longTimeTrack 长期跟踪状态.yes 是长期跟踪 not 非长期跟踪
 */
export function setLongTimeTrack(params) {
    return post('/api/lossAss/report/longTimeTrack', params)
}
/**
 * 更新邮寄信息
 * @param {*} params 
 * flowId
 * type 类型， toPost： 需邮寄
 */
export function updateExpressStatus(params) {
    return post('/api/lossAss/report/express', params);
}
/**
 * 查询案件的出险类型和出险原因
 * @param {*} params 
 * flowId
 */
export function getAccidentTypes(params) {
    return get('/api/lossAss/report/accidentTypes', params);
}


/**
 * 前海饿了么.校验保单
 * @param {*} params 
 * flowId
 */
export function validPolicyReport(params) {
    return put('/api/lossAss/qianhai/elem/report/validPolicy', params);
}

/**
 * 案件重开
 * @param {*} params 
 * flowId
 * orgAccount
 * tenant 
 */
export function reopenReport(params) {
    return post('/api/lossAss/report/reopen', params)
}
/**
 * 人保达达定损确认责任条款
 * @param {*} params
 * state
 * subState
 * flowId
 * agentId
 * policyItemKind
 */
export function updateLossAssessmentPolicy(params) {
    return post('/api/lossAss/piccDada/checked', params)
}

/**
 * 太保饿了么是否有未处理风险
 * @param {*} param 
 * flowId
 */
export function checkIsUntreatedWhenSubmit(param) {
    return get('/api/lossAss/report/eleme/risk/untreated', param)
}

/**
 * 删除处理记录
 * @param {*} params 
 * flowId
 * recordId
 */
export function deleteReportRecord(params) {
    return del('/api/lossAss/reportRecord/remove', params);
}

/**
 * 编辑、新增处理记录
 * @param {*} flowId 
 * @param {*} params 
 * @returns 
 */
export function editReportRecord(flowId, params) {
    return post(`/api/lossAss/reportRecord/edit/${flowId}`, params);
}
/**
 * 获取大地哈啰的支行
 * @param {*} params 
 * bankCode
 * provinceName
 * kw
 * @returns 
 */
export function getBranchBankByCCIC(params) {
    return get('/api/ccic/accountBanks', params);
}
/**
 * 校验人保达达订单查验
 * @param {String} tenant
 * @param {Object} params 
 * policyNo
 * accidentTime
 * @returns 
 */
export function queryUniquePolicyNo(tenant, params)  {
    if (String(tenant) === '24') {
        return post('/api/lossAss/dada/queryOrder', params);
    }
    return post('/api/lossAss/piccDada/queryOrder', params);
}
/**
 * 订单关联
 * @param {*} params 
 * @returns 
 */
export function relateUniquePolicyNoByPICC(params) {
    return put('/api/lossAss/piccDada/related/order', params);
}
/**
 * 前海达达-转办新职伤
 * @param {*} params
 * params.flowId 
 * @returns 
 */
export function workInjury(params) {
    return post('/api/lossAss/report/workinjury', params)
}
/**
 * 获取通用的产品类型
 * @param {Object} params
 * params.agentId
 * @returns 
 */
export function getRiskProducts(params) {
    return get('/api/lossAss/riskProduct/riskProducts', params)
}

/**
 * 获取京东风险列表
 * @param {*} params 
 * params.flowId
 * @returns 
 */
export function getRiskList(params) {
    return get('/api/riskContr/todo', params)
}

/**
 * 更新风险
 * @param {*} params 
 * params.flowId
 * params.riskFlagId 风险记录id
 * params.status
 * params.feedback
 * params.reason
 * params.riskList [{ _id: string, feedback: 0 | 1 }]
 * @returns 
 */
export function updateRisk(params) {
    return post('/api/riskContr/todo', params)
}

/**
 * 获取核赔任务列表
 * @param {*} params
 * page 页码
 * pageSize 每页条数
 * state 核赔状态（pending/checking/rejected/approved）
 * flowId 案件流水号
 * startTime 提交核赔开始时间
 * endTime 提交核赔结束时间
 */
export function getClaimCheckTaskList(params) {
    return get('/api/lossAss/cpic/claimCheck/taskList', params);
}

/**
 * 领取核赔任务
 * @param {*} params
 * flowId 工单受理号
 * agentId 坐席ID
 * checkId 核赔任务ID
 */
export function claimCheckTaskReceive(params) {
    return post('/api/lossAss/cpic/claimCheck/receive', params);
}

/**
 * 审核核赔任务
 * @param {*} params
 * flowId 工单受理号
 * agentId 坐席ID
 * tasks 任务列表 [{ checkId, action: 'approve'|'reject', rejectReason? }]
 */
export function reviewClaimCheckTask(params) {
    return post('/api/lossAss/cpic/claimCheck/review', params);
}

/**
 * 获取工单的核赔子任务详情
 * @param {*} params
 * flowId
 */
export function getClaimCheckTasksByFlowId(params) {
    return get('/api/lossAss/cpic/claimCheck/tasks', params);
}

// 获取计算书核赔子任务
export function getClaimCheckTasksByClaimBookId(params) {
    return get('/api/lossAss/innerClaim/claim-info-tasks', params);
}

// 审核计算书核赔子任务
export function CheckClaimBookTasks(params) {
    return post('/api/lossAss/innerClaim/claim-info-check', params);
}

/**
 * 获取领款人列表
 * @param {*} params
 * flowId
 */
export function getPaymentInfoList(params) {
    return get('/api/lossAss/paymentInfoList', params);
}

/**
 * 更新领款人列表
 * @param {*} params
 * flowId
 * paymentInfoList
 */
export function updatePaymentInfoList(params) {
    return put('/api/lossAss/paymentInfoList', params);
}

/**
 * 新增领款人
 * @param {*} params
 * flowId
 * item
 */
export function addPaymentInfoItem(params) {
    return post('/api/lossAss/paymentInfoList/add', params);
}

/**
 * 修改领款人
 * @param {*} params
 * flowId
 * index
 * item
 */
export function updatePaymentInfoItem(params) {
    return post('/api/lossAss/paymentInfoList/update', params);
}

/**
 * 删除领款人
 * @param {*} params
 * flowId
 * index
 */
export function deletePaymentInfoItem(params) {
    return post('/api/lossAss/paymentInfoList/delete', params);
}

/**
 * 获取理算书列表
 * @param {*} params
 * flowId
 */
export function getClaimInfoList(params) {
    return get('/api/lossAss/claimInfoList', params);
}

/**
 * 更新理算书列表
 * @param {*} params
 * flowId
 * claimInfoList
 */
export function updateClaimInfoList(params) {
    return post('/api/lossAss/claimInfoList/update', params);
}

/**
 * 新增理算书
 * @param {*} params
 * flowId
 * item
 */
export function addClaimInfoItem(params) {
    return post('/api/lossAss/claimInfoList/add', params);
}

/**
 * 修改理算书
 * @param {*} params
 * flowId
 * index
 * item
 */
export function updateClaimInfoItem(params) {
    return post('/api/lossAss/claimInfoList/update', params);
}

/**
 * 删除理算书
 * @param {*} params
 * flowId
 * index
 */
export function deleteClaimInfoItem(params) {
    return post('/api/lossAss/claimInfoList/delete', params);
}

/**
 * 获取内部核赔任务列表
 * @param {*} params
 * flowId
 * claimBookNo
 */
export function getInnerClaimList(params) {
    return get('/api/lossAss/innerClaim/list', params);
}

/**
 * 领取内部核赔任务
 * @param {*} params
 * _id
 */
export function claimInnerClaimTask(params) {
    return post('/api/lossAss/innerClaim/claim', params);
}

/**
 * 审核通过内部核赔任务
 * @param {*} params
 * _id
 * reviewerId
 */
export function approveInnerClaimTask(params) {
    return post('/api/lossAss/innerClaim/approve', params);
}

/**
 * 审核驳回内部核赔任务
 * @param {*} params
 * _id
 * reviewerId
 * rejectReason
 */
export function rejectInnerClaimTask(params) {
    return post('/api/lossAss/innerClaim/reject', params);
}

/**
 * 提交计算书核赔
 * @param {*} params
 * flowId
 * tenant
 * claimBookNo
 */
export function submitClaimInfo(params) {
    return post('/api/lossAss/claimInfoList/claim', params);
}

/**
 * 发起调查
 * @param {*} params 
 * flowId
 * agentId
 */
export function submitInvestigation(params) {
    return post('/api/lossAss/report/investigation', params);
}

/**
 * 查询当前登录用户对某工单是否有待追踪记录，及对应的 type 列表
 * @param {Object} params
 * flowId
 * @returns {Promise<{ hasPending: boolean, types: string[] }>}
 */
export function getMyPendingTrack(params) {
    return get('/api/lossAss/dailyFollowTrack/myPending', params);
}

/**
 * 客服追踪提交（点“未决/定损追踪”按钮提交备注后调用）
 * 会把该 flowId+type 下所有 pending 记录同步赋值 done，并写入 submitRemark 等字段
 * @param {Object} params
 * flowId
 * type: 'unresolved' 未决案件跟踪 / 'defloss' 定损任务跟踪
 * remark 备注内容
 */
export function submitDailyTrack(params) {
    return post('/api/lossAss/dailyFollowTrack/submit', params);
}

/**
 * 查询某人某天的新发/历史未决待追踪数量及开关状态
 * GET /api/lossAss/dailyFollowTrack/switchList?agentId=xxx&trackDateStr=YYYY-MM-DD
 * @param {Object} params { agentId, trackDateStr }
 * @returns { regular: { count, disabled }, longTerm: { count, disabled } }
 */
export function getTrackSwitchList(params) {
    return get('/api/lossAss/dailyFollowTrack/switchList', params);
}

/**
 * 切换某人某天某类型的追踪开关
 * POST /api/lossAss/dailyFollowTrack/switchToggle
 * 关闭时：物理删除该人该日期及之前所有 pending 记录（对应 source 分组），写入配置表
 * 开启时：删除配置表记录（已删除的记录不恢复）
 * @param {Object} params { agentId, trackDateStr, sourceType: 'regular'|'longTerm', disabled: boolean }
 */
export function toggleTrackSwitch(params) {
    return post('/api/lossAss/dailyFollowTrack/switchToggle', params);
}

/**
 * 案件关联的微信客户与客户群（PC 工单详情「微信客户」弹窗）
 * 数据来自企微侧边栏关联的两张关联表（客户关联 + 客户群关联）
 * @param {*} flowId 受理号
 * @returns {Promise<{errCode:number, result:{customers:Array, groups:Array}}>}
 */
export function fetchReportWxworkRelations(flowId) {
    return get(`/api/lossAss/report/${flowId}/wxworkRelations`);
}
